import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: monospace;
    background: rgb(229 228 228);
    position: relative;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`;
